module.exports = __webpack_public_path__ + "img/web2.960c1c11.webp";